export default class Slideshow {
    constructor() {
        this.selector = '.slideshow';
        this.init();
    }

    init() {
        var self = this,
            $slideshow = $( self.selector );

        $slideshow.slick( {
            dots: true,
            arrows: false,
            fade: true,
            autoplay: false,
            customPaging: function( slider, i ) {
                return $('<span></span>');
            },
        } );
    }
}